var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 2.02499H6.33335C3.83335 2.02499 2.16669 3.69166 2.16669 6.19166V11.1917C2.16669 13.6917 3.83335 15.3583 6.33335 15.3583V17.1333C6.33335 17.8 7.07502 18.2 7.62502 17.825L11.3334 15.3583H14.6667C17.1667 15.3583 18.8334 13.6917 18.8334 11.1917V6.19166C18.8334 3.69166 17.1667 2.02499 14.6667 2.02499ZM10.5 12.1667C10.15 12.1667 9.87502 11.8833 9.87502 11.5417C9.87502 11.2 10.15 10.9167 10.5 10.9167C10.85 10.9167 11.125 11.2 11.125 11.5417C11.125 11.8833 10.85 12.1667 10.5 12.1667ZM11.55 8.70833C11.225 8.92499 11.125 9.06666 11.125 9.29999V9.47499C11.125 9.81666 10.8417 10.1 10.5 10.1C10.1584 10.1 9.87502 9.81666 9.87502 9.47499V9.29999C9.87502 8.33333 10.5834 7.85833 10.85 7.67499C11.1584 7.46666 11.2584 7.32499 11.2584 7.10833C11.2584 6.69166 10.9167 6.34999 10.5 6.34999C10.0834 6.34999 9.74169 6.69166 9.74169 7.10833C9.74169 7.44999 9.45835 7.73333 9.11669 7.73333C8.77502 7.73333 8.49169 7.44999 8.49169 7.10833C8.49169 5.99999 9.39169 5.09999 10.5 5.09999C11.6084 5.09999 12.5084 5.99999 12.5084 7.10833C12.5084 8.05833 11.8084 8.53333 11.55 8.70833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageQuestion);
export default __webpack_public_path__ + "static/media/message-question.50a510548b8a50bf008882168ef66aa0.svg";
export { ForwardRef as ReactComponent };